import { useEffect, useRef } from 'react';
import { RequestStatus } from '@module/form';
export var useHeadingFileUpload = function useHeadingFileUpload(_ref) {
  var addHeadingFileStatus = _ref.addHeadingFileStatus,
      file = _ref.file,
      onResetAddHeadingFileUseCase = _ref.onResetAddHeadingFileUseCase;
  var richTextEditorRef = useRef(null);
  useEffect(function () {
    if (addHeadingFileStatus === RequestStatus.SUCCESS && file && file.url && richTextEditorRef.current) {
      richTextEditorRef.current.insertImageHandler(file.url);
      onResetAddHeadingFileUseCase === null || onResetAddHeadingFileUseCase === void 0 ? void 0 : onResetAddHeadingFileUseCase();
    }
  }, [addHeadingFileStatus, file, onResetAddHeadingFileUseCase]);
  return {
    richTextEditorRef: richTextEditorRef
  };
};